<template>
  <div class="time-selector-component">
    <div :class="{ 'form-group': singleInput }">
      <label class="control-label col-sm-4" v-if="singleInput">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="{ 'col-sm-8': singleInput }">
        <input class="form-control" type="hidden"
          :id="options.name"
          :name="options.name"
          :value="value"/>
        <div class="input-group">
          <span class="input-group-addon">
            <span class="fa fa-clock-o"></span>
          </span>
          <input class="form-control" type="text"
            v-model="timeLabel"
            @input="searchTimes()"
            @keydown.up.prevent="moveUpList()"
            @keydown.down.prevent="moveDownList()"
            @keydown.enter.prevent="selectTime($event)"
            @focus="showTimes()"/>
        </div>
        <div class="time-selector" v-if="selectingTime" ref="times">
          <template v-for="(time, key) in availableTimes">
            <div class="time-selector-item"
            :key="key"
            :class="{ 'active': key === selectedIndex }"
            @hover="changeIndex(key)"
            @mousedown="clickTime(key, $event)">
            <template v-if="time === '12:00pm'">
              Midday <span class="fa fa-sun-o pull-right"></span>
            </template>
            <template v-if="time === '12:00am'">
              Midnight <span class="fa fa-moon-o pull-right"></span>
            </template>
            <template v-if="time.indexOf('12:00') < 0">
              {{ time }}
              <span :class="{
                'fa-moon-o': !isDaylight(time),
                'fa-sun-o': isDaylight(time)
                }"
                class="fa pull-right"></span>
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// use to close time picker
function handleOffClick (e) {
  let clickedInside = false
  let parent = e.target.parentNode
  while (parent) {
    if (parent.className === 'time-selector-component' &&
    (e.target.className === 'form-control' ||
    e.target.className === 'time-selector') &&
    this.$refs.times && this.$refs.times.parentNode.isSameNode(parent)) {
      parent = false
      clickedInside = true
    } else {
      parent = parent.parentNode
    }
  }
  if (!clickedInside) this.closeTimes()
}
export default {
  name: 'TimeInput',
  props: {
    singleInput: {
      default () {
        return true
      }
    },
    value: {
      type: [String, Object, Date]
    },
    options: {
      type: Object,
      default () {
        return {
          required: false
        }
      }
    }
  },
  data () {
    return {
      isDirty: false,
      isValid: true,
      selectingTime: false,
      times: [],
      availableTimes: [],
      searching: false,
      timeLabel: '',
      selectedTime: moment(),
      selectedIndex: 0,
      minDate: moment().startOf('day'),
      maxDate: moment().endOf('day'),
      offClick: function () {}
    }
  },
  mounted () {
    if (this.value) {
      this.setTime(this.value)
    } else {
      this.selectedTime = null
      this.timeLabel = ''
    }
    this.refreshTimeList()
  },
  methods: {
    async showTimes () {
      for (let i = 0; i < this.availableTimes.length; i++) {
        if (this.availableTimes[i] === this.timeLabel) {
          this.selectedIndex = i
        }
      }
      this.selectingTime = true
      await this.$nextTick()
      let height = this.$refs.times.children[this.selectedIndex].clientHeight
      this.$refs.times.scrollTop = height * this.selectedIndex
      this.offClick = handleOffClick.bind(this)
      window.addEventListener('mousedown', this.offClick, false)
    },
    searchTimes () {
      if (!this.searching) {
        this.searching = setTimeout(() => {
          this.availableTimes = this.times.filter((el) => {
            if (el.indexOf(this.timeLabel) >= 0) return true
            if (el.indexOf('12:00pm') >= 0) {
              if ('midday'.indexOf(this.timeLabel.toLowerCase()) >= 0) {
                return true
              }
            }
            if (el.indexOf('12:00am') >= 0) {
              if ('midnight'.indexOf(this.timeLabel.toLowerCase()) >= 0) {
                return true
              }
            }
          })
          this.selectedIndex = 0
          clearTimeout(this.searching)
          this.searching = false
        }, '500')
      }
    },
    selectTime ($event) {
      this.timeLabel = this.availableTimes[this.selectedIndex]
      this.selectedTime = moment(this.timeLabel, 'h:mma')
      this.closeTimes()
      let target = $event.target || $event.srcElement
      target.blur()
      this.validate()
    },
    closeTimes () {
      window.removeEventListener('mousedown', this.offClick, false)
      this.selectingTime = false
    },
    validate () {
      if (this.timeLabel === '12:00pm') {
        this.timeLabel = 'Midday'
      }
      if (this.timeLabel === '12:00am') {
        this.timeLabel = 'Midnight'
      }
      this.$emit('input', this.selectedTime)
    },
    moveUpList () {
      if (this.selectedIndex > 0) {
        this.selectedIndex--
        this.changeIndex(this.selectedIndex)
      }
    },
    moveDownList () {
      if (this.selectedIndex < this.availableTimes.length - 1) {
        this.selectedIndex++
        this.changeIndex(this.selectedIndex)
      }
    },
    async changeIndex (index) {
      this.selectedIndex = index
      this.timeLabel = this.availableTimes[index]
      this.selectedTime = moment(this.timeLabel, 'h:mma')
      await this.$nextTick()
      let height = this.$refs.times.children[this.selectedIndex].clientHeight
      this.$refs.times.scrollTop = height * this.selectedIndex
      this.validate()
    },
    clickTime (index, $event) {
      this.selectedIndex = index
      this.selectTime($event)
    },
    isDaylight (time) {
      let x = moment(time, 'h:mma')
      let y = x.clone().hours(6).minutes(0).seconds(0)
      let z = x.clone().hours(18).minutes(0).seconds(0)
      return x.isBetween(y, z, 'minutes')
    },
    setTime (date) {
      if (date) {
        date = moment(date)
        let diff = date.minutes() % 15
        if (diff > 0) {
          this.selectedTime = date.add(15 - diff, 'minutes')
        } else {
          this.selectedTime = moment(date)
        }
        this.timeLabel = moment(date).format('h:mma')
      } else {
        this.selectedTime = null
        this.timeLabel = ''
      }
    },
    getTime () {
      return this.selectedTime ? this.selectedTime.toDate() : null
    },
    setMinDate (date) {
      this.minDate = moment(date)
    },
    setMaxDate (date) {
      this.maxDate = moment(date)
    },
    refreshTimeList () {
      this.times = []
      if (this.selectedTime) {
        let diff = this.selectedTime.minutes() % 15
        if (diff > 0) {
          this.selectedTime = this.selectedTime.add(15 - diff, 'minutes')
        }
      }
      let date = this.minDate.clone()
      let endOfDay = this.maxDate.clone()
      if (this.maxDate.isSame(date, 'day')) {
        endOfDay = this.maxDate.clone()
      } else {
        endOfDay = date.clone().endOf('day')
      }
      let dateDiff = date.minutes() % 15
      if (dateDiff > 0) {
        dateDiff = date.add(15 - dateDiff, 'minutes')
      }
      while (date.isSameOrBefore(endOfDay)) {
        let label = date.format('h:mma')
        this.times.push(label)
        date = date.clone().add(15, 'minutes')
      }
      this.availableTimes = this.times
      this.validate()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/TimeInput.vue